import React, { useState, useEffect } from "react";
import { Table, Spin, Button, message } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import http from "../../helpers/http";
import config from "../../config/config";
import helper from "../../helpers/helper";

const PaymentHistory = ({ datas }) => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setPayments(datas);
  }, [datas]);

  const handleInvoiceView = async (paymentId) => {
    const url = `${config?.api_url}business-plans/download-invoice/${paymentId}`;

    const link = document.createElement("a");
    link.href = url;

    // If your API needs auth via cookies → this is enough
    // If your API needs token in headers → use the Axios method below instead

    link.target = "_blank";
    link.click();
  };

  const columns = [
    {
      title: "Invoice Number",
      dataIndex: "invoiceNo",
      key: "invoiceNo",
    },
    {
      title: "Payment Method",
      dataIndex: "paymentMethod",
      key: "paymentMethod",
    },
    {
      title: "Transaction ID",
      dataIndex: "providerTransactionId",
      key: "providerTransactionId",
    },
    {
      title: "Payment Timestamp",
      dataIndex: "paymentDatetime",
      key: "paymentDatetime",
      render: (datetime) =>  helper.ISTDate(datetime),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (amount) =>  `${amount}/-`,
      
    },
    
   
    {
      title: "Invoice",
      key: "invoice",
      render: (text, record) => (
        <Button
          
          onClick={() => handleInvoiceView(record._id)}
        >
          Download
        </Button>
      ),
    },
   
  ];

  if (loading) {
    return <Spin />;
  }

  return (
    <Table
      columns={columns}
      dataSource={payments}
      rowKey="_id"
      pagination={false}
    />
  );
};

export default PaymentHistory;
